import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const PARLOUR_IMG = "/parlour-vintage.webp";

const About = () => (
  <section id="history" data-testid="about-section" className="py-28 md:py-36 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-center relative">
      <div className="lg:col-span-6">
        <SectionHeading chapter="01" overline="Our Story" title="A Taste of History" />
        <Reveal delay={0.1}>
          <p className="mt-10 text-base md:text-lg leading-relaxed text-teal/80 max-w-xl">
            The Morelli family has been crafting ice cream since 1907 — and in 1932
            they opened the doors of the parlour on the Broadstairs promenade,
            beginning a love affair between ice cream and the British seaside that
            has never faded. Today, Giuseppe Morelli — the sixth generation of the
            family — runs the business, and our Art Deco parlour remains one of the
            UK&rsquo;s most famous and beloved ice cream destinations.
          </p>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-teal/80 max-w-xl">
            Every scoop is still churned with the same devotion to craft: fresh dairy,
            time-honoured recipes, and a dash of seaside magic. From Charles Dickens
            festivals to summer holidays on Viking Bay, Morelli&rsquo;s has been the
            sweet heart of the Kent coastline for over ninety years.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
          {[["119", "Years of craft"], ["18+", "Flavour display"], ["6", "Generations"]].map(([n, label]) => (
            <div key={label} className="border-l-2 border-gold pl-4">
              <p className="font-display font-bold text-3xl md:text-4xl text-teal">{n}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-teal/60 mt-1">{label}</p>
            </div>
          ))}
        </Reveal>
      </div>
      <div className="lg:col-span-6 relative flex justify-center lg:justify-end">
        <Reveal delay={0.15} className="relative">
          <div className="absolute -inset-4 rounded-t-full rounded-b-[2.5rem] border border-gold/60" aria-hidden="true" />
          <div className="absolute -inset-4 rounded-t-full rounded-b-[2.5rem] border border-gold/25 scale-[1.04]" aria-hidden="true" />
          <div className="relative rounded-t-full rounded-b-[2rem] overflow-hidden border-[5px] border-white shadow-2xl shadow-teal/20 w-72 md:w-96 aspect-[3/4]">
            <img src={PARLOUR_IMG} alt="The original Morelli's parlour counter in the mid-twentieth century" data-testid="about-image" className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-700" loading="lazy" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
